import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function HeaderNav() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <motion.header
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-black/60 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <a
          href="#top"
          data-testid="nav-logo-link"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="font-mono text-sm font-bold tracking-[0.25em] text-slate-50"
        >
          FITNANCE<span className="text-emerald-400">.</span>
        </a>

        <nav className="hidden items-center gap-8 font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-400 md:flex">
          <button onClick={() => scrollTo("chapters")} className="transition-colors duration-300 hover:text-emerald-400">
            Manifesto
          </button>
          <button onClick={() => scrollTo("preview")} className="transition-colors duration-300 hover:text-emerald-400">
            Preview
          </button>
          <button onClick={() => scrollTo("support")} className="transition-colors duration-300 hover:text-emerald-400">
            Support
          </button>
          <Link
            to="/admin"
            data-testid="nav-admin-access-button"
            className="text-neutral-600 transition-colors duration-300 hover:text-emerald-400"
            aria-label="Admin"
          >
            •
          </Link>
        </nav>

        <button
          data-testid="nav-waitlist-button"
          onClick={() => scrollTo("waitlist")}
          className="rounded-full bg-emerald-500 px-5 py-2 font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-emerald-950 transition-all duration-300 hover:scale-[1.03] hover:bg-emerald-400 hover:shadow-[0_0_24px_rgba(16,185,129,0.4)]"
        >
          Join waitlist
        </button>
      </div>
    </motion.header>
  );
}
